import { render, staticRenderFns } from "./newRegion.vue?vue&type=template&id=6e8a9b9c&scoped=true&"
import script from "./newRegion.vue?vue&type=script&lang=js&"
export * from "./newRegion.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./newRegion.vue?vue&type=style&index=1&id=6e8a9b9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8a9b9c",
  null
  
)

export default component.exports